const snack = require('../../../../../components/snack/snack')
const snackP = require('./purchase-snack')
const otherfieldHandler = require('./purchase-fullcont-otherfield-handler')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const handlerPurchase = require('./purchase-fullcont-handler')
//aqui se guarda la existencia de los articulos al momento de cargar el fullcont, luego del select one
// la existencia es igual a cantidad menos lo vendido, no se restaran las cantidades en lost
// ya que se usara este arreglo para ese multitable
// es decir que la existencia sin los lost se usara para hacer este calculo: total de lost - la existencia
export var inventoryStock = [];

//Se guarda el credito gastado para validar que no se coloque menos credito del que se a gastado 
export var spendCredit = 0;

export function calculateInvoiceTotal(data, htmlFc) {
  const input_invoice_total = document.querySelector("#purchase_total_invoice");
  const inputTotalValue = input_invoice_total.querySelector("input");

  let totalItemsPrice = 0.00;
  let totalReturned = 0.00;

  if (data && data.data && data.data.length > 0) {

    const mtItems = data.multiTables.find(
      table => table.tableName === 'purchase_vs_item'
    )?.data ?? [];
    mtItems.forEach(m => {
      totalItemsPrice +=
        parseFloat(m.total_price) ?? 0;
    });


    const mtReturn = data.multiTables.find(
      table => table.tableName === 'purchase_vs_lost'
    )?.data ?? [];
    mtReturn.forEach(m => {
      if (m.return_item == "true") {
        totalReturned +=
          parseFloat(m.lost_price) ?? 0;
      }
    });

    const totalValue = parseFloat(totalItemsPrice - totalReturned);
    inputTotalValue.value = totalValue.toFixed(2);

    return;
  }

  let mtItems = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_item");
  let mtReturn = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_lost");
  let lineitmes = mtItems.querySelectorAll('.line');
  let linereturn = mtReturn.querySelectorAll('.line') || null;

  let totalVenta = 0;
  let totalReturn = 0;

  lineitmes.forEach(l => {
    let input_qty = l.querySelector('.qty input');
    let input_unit_price = l.querySelector('.unit_price input');

    let qty = parseFloat(input_qty.value) || 0;
    let price = parseFloat(input_unit_price.value) || 0;

    totalVenta += qty * price;
  });

  if (linereturn != null) {
    linereturn.forEach(l => {
      let input_return = l.querySelector('.return_item input[type="checkbox"]');
      if (input_return.checked === true) {
        let input_lost_price = l.querySelector('.lost_price input');
        let input_lost_qty = l.querySelector('.lost_qty input');

        let price = parseFloat(input_lost_price.value) || 0;

        totalReturn += price;
      }
    })

  }

  inputTotalValue.value = (totalVenta - totalReturn).toFixed(2) || 0.00;

  return;
}

export function checkOtherCostItem(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_expenses_mt_" + detail.id_expenses_ac);
  let input_other_cost = ac_line.closest('.line').querySelector('.other_cost input').checked;
}

export function noDecimal(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_item_mt_" + detail.id_item_ac);
  let input_qty = ac_line.closest('.line').querySelector('.qty input');

  if (!isNaN(parseFloat(input_qty.value)) && /\.\d+/.test(input_qty.value)) {
    snackP.start({ act: 'show', id: 'noDecimal', });
  }
}

export function calculate_values_p_vs_item(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_item_mt_" + detail.id_item_ac);
  // let ac_line2 = htmlFc.fullcontHTML.querySelector("#purchase_form_item_mt_chat_" + detail.id_item_ac);
  let input_qty = ac_line.closest('.line').querySelector('.qty input');
  let input_unit_price = ac_line.closest('.line').querySelector('.unit_price input');
  let input_total_price = ac_line.closest('.line').querySelector('.total_price input');

  // let input_qty2 = ac_line2.closest('.line').querySelector('.qty input');
  // let input_total_price2 = ac_line2.closest('.line').querySelector('.total_price input');

  let qty_value = (input_qty.value == "" || parseFloat(input_qty.value) == NaN || parseFloat(input_qty.value) == 0) ? 0 : parseFloat(input_qty.value);
  let price_value = (input_unit_price.value == "" || parseFloat(input_unit_price.value) == NaN || parseFloat(input_unit_price.value) == 0) ? 0 : parseFloat(input_unit_price.value);
  let total_value = (input_total_price.value == "" || parseFloat(input_total_price.value) == NaN || parseFloat(input_total_price.value) == 0) ? 0 : parseFloat(input_total_price.value);

  switch (detail.input) {

    case "qty":
      if (qty_value != 0 || qty_value != "") {
        // input_qty2.value = qty_value
      }

      if (price_value !== 0) {
        input_total_price.value = (price_value * qty_value).toFixed(2);
        // input_total_price2.value = (price_value * qty_value).toFixed(2);
      }
      break;

    case "unit_price":
      if (price_value === 0) {
        return;
      }

      if (qty_value !== 0) {
        input_total_price.value = (qty_value * price_value).toFixed(2);
      }
      break;

    case "total_price":
      if (total_value === 0) {
        return;
      }

      if (qty_value !== 0) {
        input_unit_price.value = (total_value / qty_value).toFixed(2);
      }
      break;

    default:
      break;
  }

  // si el fullcont esta en modo edicion debe de actualizar los inputs que reflajaran los cambios con respecto a los return
  if (!htmlFc.fullcontHTML.classList.contains('mode-add')) {
    handlerPurchase.fillInputReturnMtItem(true)
  }
}

export function sellingPrice(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector(
    "#purchase_form_item_mt_" + detail.id_item_ac
  );
  if (ac_line) {
    setTimeout(() => {
      let input_unit_price = ac_line
        .closest(".line")
        .querySelector(".unit_price input");
      let input_selling_price = ac_line
        .closest(".line")
        .querySelector(".selling_price input");
      let add_class_to_input_selling = ac_line
        .closest(".line")
        .querySelector(".selling_price");
      let update_button = htmlFc.fullcontHTML.querySelector("#update_button");

      let price_value =
        input_unit_price.value == "" ||
          parseFloat(input_unit_price.value) == NaN ||
          parseFloat(input_unit_price.value) == 0
          ? 0
          : parseFloat(input_unit_price.value);
      let selling_value =
        input_selling_price.value == "" ||
          parseFloat(input_selling_price.value) == NaN ||
          parseFloat(input_selling_price.value) == 0
          ? 0
          : parseFloat(input_selling_price.value);

      switch (detail.input) {
        case "selling_price":
          if (selling_value < price_value) {
            add_class_to_input_selling.classList.add("textfield-error");
            snack.start({ act: "show", id: "sellingError" });
          } else {
            add_class_to_input_selling.classList.remove("textfield-error");
          }
          break;

        case "unit_price":
          if (price_value > selling_value) {
            add_class_to_input_selling.classList.add("textfield-error");
            snack.start({ act: "show", id: "sellingError" });
          } else {
            add_class_to_input_selling.classList.remove("textfield-error");
          }
          break;
      }
    }, 300);
  } else {
    console.log("no hay ac line")
  }
}

export function calculate_values_p_vs_investment(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_investment_mt_" + detail.id_investmet_ac);
  let min_amount = htmlFc.fullcontHTML.querySelector("#purchase_form_min_amount").querySelector(".elem").value;
  let update_button = htmlFc.fullcontHTML.querySelector("#update_button");

  let input_invested_amount = ac_line.closest('.line').querySelector('.invested_amount input');
  let input_revenue = ac_line.closest('.line').querySelector('.revenue input');
  let input_revenue_amount = ac_line.closest('.line').querySelector('.revenue_amount input');

  let invested_amount_value = (input_invested_amount.value == "" || parseFloat(input_invested_amount.value) == NaN || parseFloat(input_invested_amount.value) == 0) ? 0 :
    parseFloat(input_invested_amount.value);
  let revenue_value = (input_revenue.value == "" || parseFloat(input_revenue.value) == NaN || parseFloat(input_revenue.value) == 0) ? 0 :
    parseFloat(input_revenue.value);
  let revenue_amount_value = (input_revenue_amount.value == "" || parseFloat(input_revenue_amount.value) == NaN || parseFloat(input_revenue_amount.value) == 0) ? 0 :
    parseFloat(input_revenue_amount.value);

  if (invested_amount_value > min_amount) {
    update_button.classList.add('hideOnEdit');
    input_invested_amount.style.setProperty('color', '#EF1010', 'important');
    snack.start({ act: 'show', id: 'minAmountError', });
  } else {
    update_button.classList.remove('hideOnEdit');
    input_invested_amount.style.setProperty('color', '#000', 'important');
  }

  switch (detail.input) {
    case "invested_amount":
      if (invested_amount_value === 0) {
        return;
      }

      if (revenue_value !== 0) {
        input_revenue_amount.value = (invested_amount_value * revenue_value).toFixed(2);
      }
      if (revenue_amount_value !== 0) {
        input_revenue.value = (revenue_amount_value / invested_amount_value).toFixed(2);
      }
      break;

    case "revenue":
      if (revenue_value === 0) {
        return;
      }

      if (invested_amount_value !== 0) {
        input_revenue_amount.value = (invested_amount_value * revenue_value).toFixed(2);
      }
      break;

    case "revenue_amount":
      if (revenue_amount_value === 0) {
        return;
      }

      if (invested_amount_value !== 0) {
        input_revenue.value = (revenue_amount_value / invested_amount_value).toFixed(2);
      }
      break;

    default:
      break;
  }
}


// Este total es solo visual. Se mantiene separado de calculateGrandTotal para poder
// calcularlo al cargar el fullcont sin reescribir campos persistidos ni activar wasEdited.
export function calculateCogsTotal(htmlFc) {
  let total_cogs          = htmlFc.fullcontHTML.querySelector("#purchase_general_total_cogs");
  let suma_total_cogs     = 0;
  const ac_line           = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_item");

  if (ac_line) {
    ac_line.querySelectorAll(".cogs_row_amount").forEach((e) => {
      let a          = e.querySelector("input[type='number']");
      let valor      = parseFloat(a.value) || 0;
      suma_total_cogs += valor;
    });
  }

  total_cogs.querySelector("input[type='text']").value = suma_total_cogs.toFixed(2);
}

export function calculateGrandTotal(htmlFc) {
  let total_price         = htmlFc.fullcontHTML.querySelector("#purchase_general_total_price");
  let total_selling       = htmlFc.fullcontHTML.querySelector("#purchase_general_total_selling_price");
  let total_expenses      = htmlFc.fullcontHTML.querySelector("#purchase_general_total_expenses");
  let suma_total_price    = 0;
  let suma_total_selling  = 0;
  let suma_total_expenses = 0;
  const ac_line           = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_item");

  // purchase_vs_item ///////////////////////////////////////////
  // Verificar si ac_line no es null antes de intentar iterar sobre sus descendientes
  if (ac_line) {
    // Obtener todos los elementos descendientes de ac_line
    const descendientesA = ac_line.querySelectorAll(".total_price");
    const descendientesB = ac_line.querySelectorAll(".selling_price");

    // Iterar sobre los descendientes
    descendientesA.forEach((e) => {
      let a             = e.querySelector("input[type='number']");
      let valor         = parseFloat(a.value) || 0;
      suma_total_price += valor;
    });

    // Iterar sobre los descendientes
    descendientesB.forEach((e) => {
      let a               = e.querySelector("input[type='number']");
      let input_qty       = e.closest('.line').querySelector('.qty input').value;
      let valor           = parseFloat(a.value) || 0;
      suma_total_selling += (valor * input_qty);
    });
  }

  total_price.querySelector("input[type='text']").value = suma_total_price.toFixed(2);
  total_selling.querySelector("input[type='text']").value = suma_total_selling.toFixed(2);
  calculateCogsTotal(htmlFc);

  // purchase_vs_expense ///////////////////////////////////////////
  const ac_line_expenses = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_expenses");

  // Verificar si ac_line no es null antes de intentar iterar sobre sus descendientes
  if (ac_line_expenses) {
    // Obtener todos los elementos descendientes de ac_line_expenses
    const descendientesA = ac_line_expenses.querySelectorAll(".amount");

    // Iterar sobre los descendientes
    descendientesA.forEach((e) => {
      let a                = e.querySelector("input[type='number']");
      let valor            = parseFloat(a.value) || 0;
      suma_total_expenses += valor;
    });

  }

  total_expenses.querySelector("input[type='text']").value = suma_total_expenses.toFixed(2);

  calculateInvoiceTotal(null,htmlFc);

}

export function calculate_values_p_vs_lost(detail, htmlFc) {

  let line = detail.ev.target.closest('.line');
  let input_item = line.querySelector('.purchase_vs_itemId');
  let item_selected = input_item.getAttribute("selected");
  //verificar si hay un articulo seleccionado
  if (JSON.parse(item_selected).length > 0) {

    let input_lost_qty = line.querySelector('.lost_qty input');
    let input_lost_price = line.querySelector('.lost_price input');
    let qty_value = (input_lost_qty.value == "" || parseFloat(input_lost_qty.value) == NaN || parseFloat(input_lost_qty.value) == 0) ? 0 :
      parseFloat(input_lost_qty.value);
    let itemOtherField = otherfieldHandler.get_otherField(input_item);
    let price = (itemOtherField.unit_price == "" || parseFloat(itemOtherField.unit_price) == NaN
      || parseFloat(itemOtherField.unit_price) == 0) ? 0 : parseFloat(itemOtherField.unit_price);

    input_lost_price.value = "";

    if (qty_value == 0) {
      textfieldHandler.errorClean(input_lost_qty.closest(".textfield"));
      return;
    }

    let qty_available = getQtyAvailable(itemOtherField.purchase_vs_itemId);

    if (!verifyQtyItem(itemOtherField.purchase_vs_itemId, qty_available, htmlFc)) {
      return;
    }

    input_lost_price.value = (qty_value * price).toFixed(2);

  } else {
    return;
  }

  calculate_total_lost_returned();

}

//verificar las cantidades del articulo vs las que hay en existencia
export function verifyQtyItem(purchase_vs_itemId, qty_available, htmlFc) {
  let lines = [];
  let total_qty = 0;
  let allLine = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_lost  .line");

  //se agrupan los ac que tengan el mismo articulo y se suman las cantidades de estos
  for (let index = 0; index < allLine.length; index++) {
    let line = allLine[index];
    let ac_item = line.querySelector(".purchase_vs_itemId")
    let item_selected = ac_item.getAttribute("selected");
    item_selected = JSON.parse(item_selected);
    if (item_selected.length > 0) {

      if (item_selected[0] == purchase_vs_itemId) {
        let input_lost_qty = line.querySelector(".lost_qty input");
        let qty_value = (input_lost_qty.value == "" || parseFloat(input_lost_qty.value) == NaN || parseFloat(input_lost_qty.value) == 0) ? 0 :
          parseFloat(input_lost_qty.value);

        if (qty_value > 0) {
          total_qty = total_qty + qty_value;
          lines.push(line);
        }
      }
    }
  }

  //si la cantidad todal sumada es mayor a la disponible pues mostrar mensaje y colocar los inputs en rojo
  if (total_qty > qty_available) {
    for (let index = 0; index < lines.length; index++) {
      let input_lost_qty = lines[index].querySelector(".lost_qty");
      textfieldHandler.error(input_lost_qty);
    }
    snackP.start({ act: 'show', id: 'insufficientQuantity', });
    return false;
  } else {
    for (let index = 0; index < lines.length; index++) {
      let input_lost_qty = lines[index].querySelector(".lost_qty");
      textfieldHandler.errorClean(input_lost_qty);
    }
  }

  return true;
}


//verificar que la suma total de los item con return sea mayor o igual al spent credit
export function verifySpentCredit(htmlFc) {
  let lines = [];
  let total_price = 0;
  let allLine = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_lost  .line");

  for (let index = 0; index < allLine.length; index++) {
    let line = allLine[index];
    let ac_item = line.querySelector(".purchase_vs_itemId")
    let item_selected = ac_item.getAttribute("selected");
    item_selected = JSON.parse(item_selected);
    if (item_selected.length > 0) {

      let input_return = line.querySelector('.return_item input');
      if (input_return.checked) {
        let input_lost_price = line.querySelector(".lost_price input");
        let lost_price_value = (input_lost_price.value == "" || parseFloat(input_lost_price.value) == NaN || parseFloat(input_lost_price.value) == 0) ? 0 :
          parseFloat(input_lost_price.value);

        if (lost_price_value > 0) {
          total_price = total_price + lost_price_value;
          lines.push(line);

        }
      }

    }
  }

  if (total_price < spendCredit) {
    for (let index = 0; index < lines.length; index++) {
      let input_lost_qty = lines[index].querySelector(".lost_qty");
      textfieldHandler.error(input_lost_qty);
    }
    snackP.start({ act: 'show', id: 'insufficientPrice', total_price: total_price, spendCredit: spendCredit });
    return false;
  } else {
    for (let index = 0; index < lines.length; index++) {
      let input_lost_qty = lines[index].querySelector(".lost_qty");
      textfieldHandler.errorClean(input_lost_qty);
    }
  }

  return true;
}


export function fill_InventoryStock_spentCredit(data) {
  let result_inventory = JSON.parse(data.inventory_stock);
  inventoryStock = [];
  result_inventory[0].data.forEach(element => {
    inventoryStock.push(element);
  });

  spendCredit = 0;
  spendCredit = parseFloat(JSON.parse(data.spent_credit));
}

//funcion para traer la existencia de un articulo del array inventoryStock
export function getQtyAvailable(purchase_vs_itemId) {
  let qty_available = 0;
  for (let index = 0; index < inventoryStock.length; index++) {
    if (purchase_vs_itemId == inventoryStock[index].id) {
      qty_available = inventoryStock[index].qty_available;
      break;
    }
  }

  return parseFloat(qty_available);
}

export function calculate_total_lost_returned() {

  let all_line = document.querySelectorAll("#purchase_form_purchase_vs_lost .line");
  let input_total_lost = document.querySelector("#purchase_form_total_lost input");
  let input_total_returned = document.querySelector("#purchase_form_total_returned input");
  let input_total_general = document.querySelector("#purchase_form_general_lost input");
  let total_lost = 0;
  let total_returned = 0;
  let total_general = 0;

  if (all_line != undefined && all_line != null) {
    all_line.forEach(function (element) {
      let input_price = element.querySelector('.lost_price input');
      let price_value = (input_price.value == "" || parseFloat(input_price.value) == NaN || parseFloat(input_price.value) == 0) ? 0 : parseFloat(input_price.value);
      let input_return = element.querySelector('.return_item input');

      if (input_return.checked) {
        total_returned = total_returned + price_value;
      } else {
        total_lost = total_lost + price_value;
      }

    });
  }

  total_general = total_lost + total_returned;
  input_total_lost.value = `${parseFloat(total_lost).toFixed(2)}`;
  input_total_returned.value = `${parseFloat(total_returned).toFixed(2)}`;
  input_total_general.value = `${parseFloat(total_general).toFixed(2)}`;

}

